var _filter, _marker, _marker2, _rect, _rect2, _pattern, _text, _text2, _g, _text3, _text4, _circle, _circle2, _path, _g2, _text5, _text6, _rect3, _circle3, _circle4, _circle5, _rect4, _rect5, _g3, _text7, _text8, _circle6, _circle7, _path2, _path3, _path4, _circle8, _g4, _text9, _text10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01WebsocketFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clientGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ef4444"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.15
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#6366f1"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowheadOrange",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#f59e0b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "url(#bgPattern)",
    opacity: 0.03
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "bgPattern",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 45,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    WebSocket Communication Flow\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 70,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    All data passes through the server\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 150,
    width: 150,
    height: 100,
    rx: 16,
    fill: "url(#clientGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 175,
    width: 110,
    height: 50,
    rx: 8,
    fill: "#1e1b4b",
    opacity: 0.3
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 208,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 600
  }, "\n    User A\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 235,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "\n    Browser\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 25,
    fill: "#6366f1",
    stroke: "#818cf8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "25;27;25",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 118,
    r: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 110 138 Q 125 128 140 138",
    stroke: "#fff",
    strokeWidth: 3,
    fill: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 140,
    width: 150,
    height: 120,
    rx: 16,
    fill: "url(#serverGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 165,
    width: 110,
    height: 70,
    rx: 8,
    fill: "#1c1917",
    opacity: 0.3
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 205,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 600
  }, "\n    Server\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 230,
    textAnchor: "middle",
    fill: "#fef3c7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "\n    WebSocket Server\n  ")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 95,
    width: 40,
    height: 35,
    rx: 4,
    fill: "#f59e0b",
    stroke: "#fbbf24",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.8;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 108,
    r: 3,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 108,
    r: 3,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 108,
    r: 3,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 115,
    width: 30,
    height: 3,
    rx: 1,
    fill: "#fff",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 121,
    width: 20,
    height: 3,
    rx: 1,
    fill: "#fff",
    opacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 150,
    width: 150,
    height: 100,
    rx: 16,
    fill: "url(#clientGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 175,
    width: 110,
    height: 50,
    rx: 8,
    fill: "#1e1b4b",
    opacity: 0.3
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 675,
    y: 208,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 600
  }, "\n    User B\n  ")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 675,
    y: 235,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "\n    Browser\n  ")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 125,
    r: 25,
    fill: "#6366f1",
    stroke: "#818cf8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "25;27;25",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 118,
    r: 8,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 660 138 Q 675 128 690 138",
    stroke: "#fff",
    strokeWidth: 3,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 200 L 325 200",
    stroke: "#6366f1",
    strokeWidth: 3,
    strokeDasharray: "8,4",
    markerEnd: "url(#arrowhead)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 475 200 L 600 200",
    stroke: "#f59e0b",
    strokeWidth: 3,
    strokeDasharray: "8,4",
    markerEnd: "url(#arrowheadOrange)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#a78bfa"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    path: "M 200 200 L 325 200 L 475 200 L 600 200"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -20,
    width: 200,
    height: 40,
    rx: 20,
    fill: "#ef4444",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 500
  }, "\n      \u26A0\uFE0F Higher Latency (Server Hop)\n    "))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 180,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "\n    1. Send\n  ")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 537,
    y: 180,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "\n    2. Forward\n  ")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01WebsocketFlow);
export default __webpack_public_path__ + "static/media/01-websocket-flow.17f737cb22f2e8f72ff8a753bba8b138.svg";
export { ForwardRef as ReactComponent };